export var PriceListStatus;
(function (PriceListStatus) {
    PriceListStatus[PriceListStatus["Updated"] = 1] = "Updated";
    PriceListStatus[PriceListStatus["Unknown2"] = 2] = "Unknown2";
    PriceListStatus[PriceListStatus["Unknown3"] = 3] = "Unknown3";
    PriceListStatus[PriceListStatus["Unknown4"] = 4] = "Unknown4";
    PriceListStatus[PriceListStatus["Generating"] = 5] = "Generating";
})(PriceListStatus || (PriceListStatus = {}));
